module.exports = __webpack_public_path__ + "static/media/29.dc9230a6.png";